import { FormControl, MenuItem, Select, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useQueryParams } from "../../../../../hooks/useQueryParams";
import Colors from "../../../../global/Colors";

export default function StatusSelect({ defaultSelection, optionsList, setSelectionInParent }) {
  const { updateFilter } = useQueryParams();
  const [selected, setSelected] = useState(defaultSelection);

  useEffect(() => {
    const selectedLabel = optionsList.find((g) => g.label === defaultSelection);
    setSelected(selectedLabel.value);
  }, [defaultSelection]);

  const handleSubmit = (selection) => {
    setSelected(selection);
    updateFilter("status", selection);
    const selectedLabel = optionsList.find((g) => g.value === selection);
    setSelectionInParent(selectedLabel.label);
  };

  return (
    <div className="">
      <Tooltip title={"Select Status"} placement="right">
        <FormControl className="border-none text-sm" size="small">
          <Select
            className="w-full border-none text-sm"
            labelId="document-status"
            id="action-items-status-select"
            value={selected}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            onChange={(e) => handleSubmit(e.target.value)}
            sx={{
              color: Colors.white,
              backgroundColor: "#4C2AC6",
              boxShadow: "none",
              border: "1px solid #4C2AC6",
              borderRadius: "35px",
              minWidth: "150px",

              "& .MuiSvgIcon-root": {
                color: Colors.white,
              },
            }}
            inputProps={{
              MenuProps: {
                autoFocus: false,
                MenuListProps: {
                  sx: {
                    color: Colors.gray[800],
                    backgroundColor: Colors.white,
                  },
                },
              },
            }}
          >
            {!optionsList ? (
              <MenuItem>No results</MenuItem>
            ) : (
              optionsList.map((type) => (
                <MenuItem value={type.value} key={type.value}>
                  {type.label}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </Tooltip>
    </div>
  );
}
